import type { GameModule } from '../../core/contracts'
import {
  INITIAL_LEVEL,
  MAX_LEVEL,
  MIN_LEVEL,
  REFERENCE_RT_MS,
  evaluate,
  generateRound,
} from './logic'
import type { SnowflakeAnswer, SnowflakeRound } from './logic'
import { SnowflakeView } from './view'

/**
 * Первая игра третьей дисциплины - восприятия.
 * Образец остаётся перед глазами, запоминать нечего: трудность
 * в различении формы, а не в удержании её в памяти.
 */
export const snowflake: GameModule<SnowflakeRound, SnowflakeAnswer> = {
  id: 'snowflake',
  titleKey: 'game.snowflake',
  hintKey: 'game.snowflake.hint',
  discipline: 'perception',
  metric: 'speed-accuracy',
  difficulty: { min: MIN_LEVEL, max: MAX_LEVEL, initial: INITIAL_LEVEL },
  roundsPerSession: 4,
  referenceRtMs: REFERENCE_RT_MS,
  generateRound,
  evaluate,
  View: SnowflakeView,
}

export * from './logic'
